export function getSubject(id, label) {
    return { id, label };
}
export function getAvailabilityResult(id, availability, coverage = null) {
    return { id, availability, coverage };
}
/**
 * Translate column coverage into rows per feature class
 * @param {ColumnCoverage[]} columnCoverages
 * @param {system-metadata.Column[]} columns
 * @return {object[]}
 */
export function getRowsFromColumnCoverages(columnCoverages, columns) {
    const ids = columns.map((column) => column.id);
    const featureClasses = new Map();
    // Flatten entries out so 1 result per column
    const coverageByFeatureClassID = columnCoverages.reduce((memo, columnCoverage) => {
        const { featureClass } = columnCoverage;
        featureClasses.set(columnCoverage.featureClass.id, columnCoverage.featureClass);
        const entries = columnCoverage.columns.map((columnId) => ({
            ...columnCoverage,
            columns: [columnId],
        }));
        memo[featureClass.id] = memo[featureClass.id] || [];
        memo[featureClass.id].push(...entries);
        return memo;
    }, {});
    // Reshape into entry per feature class
    const transformed = [...featureClasses.values()].map((featureClass) => {
        // Match provided column order
        const coverages = coverageByFeatureClassID[featureClass.id];
        const coveragesByColumnID = coverages.reduce((memo, coverage) => {
            const id = coverage.columns[0];
            memo[id] = getAvailabilityResult(id, coverage.coverageRatio, coverage.populationCoverageRatio);
            return memo;
        }, {});
        const ordered = ids.map((id) => coveragesByColumnID[id]);
        return [
            {
                ...getSubject(featureClass.id, featureClass.friendlyLongName),
                order: featureClass.order,
            },
            ...ordered,
        ];
    });
    // Sort by feature class order
    return transformed.sort((lhs, rhs) => lhs[0].order - rhs[0].order);
}
/**
 * @param {feature-references.FeatureRecord[]} features
 * @param {references.ValueCollection} values
 * @param {system-metadata.Column[]} columns
 * @return {object[]}
 */
export function getRowsFromValueCollection(features, values, columns) {
    return features.map((feature) => ([
        getSubject(feature.id, feature.label),
        ...columns.map((column) => getAvailabilityResult(column.id, Number.isFinite(values.valueFor(feature, column.toDataReference())))),
    ]));
}
/**
 * @param {references.ValueCollection} values
 * @param {system-metadata.Column[]} columns
 * @return {object[]}
 */
export function getSummaryFromValueCollection(values, columns) {
    return [
        getSubject('summary', 'Summary'),
        ...columns.map((column) => {
            const all = Object.values(values.valuesForData(column.toDataReference()));
            const withData = all.filter((value) => Number.isFinite(value));
            return getAvailabilityResult(column.id, withData.length / all.length);
        }),
    ];
}
/**
 * @memberof availability
 */
const AvailabilityPresenter = {
    getSubject,
    getAvailabilityResult,
    getRowsFromColumnCoverages,
    getRowsFromValueCollection,
    getSummaryFromValueCollection,
};
export default AvailabilityPresenter;
